// src/pages/Profile/components/ProfileIdentityCards.jsx

import React from "react";
import { FaEnvelope, FaUser } from "react-icons/fa";

export default function ProfileIdentityCards({ displayName, email }) {
  return (
    <div className="mt-8 grid gap-4 sm:grid-cols-2">
      <div className="rounded-[1.7rem] border border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/5">
        <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <FaUser />
        </div>

        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
          Identité
        </p>

        <p className="mt-2 text-lg font-bold text-slate-950 dark:text-white">
          {displayName}
        </p>
      </div>

      <div className="rounded-[1.7rem] border border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/5">
        <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <FaEnvelope />
        </div>

        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
          Email
        </p>

        <p className="mt-2 break-all text-lg font-bold text-slate-950 dark:text-white">
          {email || "Non renseigné"}
        </p>
      </div>
    </div>
  );
}